var blueTheme = {
    global: {
        colors: {
            brand: "#009FE3",
        },
    },
};
var cyanTheme = {
    global: {
        colors: {
            brand: "#4EFFDF",
        },
    },
};
var greenTheme = {
    global: {
        colors: {
            brand: "#179D5D",
        },
    },
};
var yellowTheme = {
    global: {
        colors: {
            brand: "#EDC538",
        },
    },
};
var orangeTheme = {
    global: {
        colors: {
            brand: "#FF9900",
        },
    },
};
var redTheme = {
    global: {
        colors: {
            brand: "#FF4E58",
        },
    },
};
var pinkTheme = {
    global: {
        colors: {
            brand: "#FF4EB8",
        },
    },
};
var purpleTheme = {
    global: {
        colors: {
            brand: "#864EFF",
        },
    },
};
export var themes = [
    blueTheme,
    cyanTheme,
    greenTheme,
    yellowTheme,
    orangeTheme,
    redTheme,
    pinkTheme,
    purpleTheme,
];
//# sourceMappingURL=themes.js.map